import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    products : null,
    addOnIds: []
};

const productSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setAddOnIds: (state, action) => {
      state.addOnIds = action.payload;
    },
  }
});

export const { 
  setProducts,
  setAddOnIds
} = productSlice.actions;

export default productSlice.reducer;
